import React from 'react';
import { Button } from '../ui/Button';

export interface AppBarProps {
  title?: string;
  subtitle?: string;
  leading?: React.ReactNode;
  leadingAction?: () => void;
  actions?: React.ReactNode[];
  className?: string;
  transparent?: boolean;
  elevation?: boolean;
}

export const AppBar: React.FC<AppBarProps> = ({
  title,
  subtitle,
  leading,
  leadingAction,
  actions = [],
  className = '',
  transparent = false,
  elevation = true,
}) => {
  return (
    <header
      className={`
        app-bar ${elevation ? 'shadow-elevation-1' : ''}
        ${transparent ? 'bg-transparent border-none' : ''}
        ${className}
      `}
      role="banner"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {leading ? (
          <Button
            variant="icon"
            className="text-on-surface"
            onClick={leadingAction}
            aria-label="Voltar"
          >
            {leading}
          </Button>
        ) : (
          <div className="w-10" />
        )}
        <div className="flex-1 min-w-0 text-start">
          {title && <h1 className="font-headline-sm truncate">{title}</h1>}
          {subtitle && <p className="font-label-sm text-on-surface-variant truncate">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-1">
        {actions.map((action, index) => (
          <React.Fragment key={index}>{action}</React.Fragment>
        ))}
      </div>
    </header>
  );
};